function Orientacion() {
  return (
    <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem' }}>
      <h1>Orientación Social</h1>
      <p>Sección en construcción. Pendiente definir público objetivo y alcance.</p>
    </section>
  );
}

export default Orientacion;
